import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, isRef as _isRef, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "mb-3" }
const _hoisted_4 = { class: "mb-1" }
const _hoisted_5 = { class: "mb-1" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "mb-1" }
const _hoisted_9 = { class: "mb-1" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = {
  key: 0,
  class: "mb-1"
}
const _hoisted_13 = { class: "mb-1" }
const _hoisted_14 = { class: "mb-1" }
const _hoisted_15 = { class: "mb-1" }
const _hoisted_16 = { class: "mb-1" }
const _hoisted_17 = { class: "mb-1" }
const _hoisted_18 = { class: "mb-1" }
const _hoisted_19 = { class: "mb-1" }
const _hoisted_20 = { class: "mb-1" }
const _hoisted_21 = {
  key: 1,
  class: "mb-1"
}
const _hoisted_22 = {
  key: 0,
  class: "mt-3"
}
const _hoisted_23 = { class: "mt-3 mb-1" }
const _hoisted_24 = { key: 2 }
const _hoisted_25 = { class: "mb-1" }
const _hoisted_26 = { class: "mb-1" }
const _hoisted_27 = { class: "mb-1" }
const _hoisted_28 = { class: "mb-1" }
const _hoisted_29 = { class: "mb-1" }
const _hoisted_30 = { class: "mb-1" }
const _hoisted_31 = { class: "mb-1" }
const _hoisted_32 = ["innerHTML"]
const _hoisted_33 = { key: 3 }
const _hoisted_34 = ["innerHTML"]
const _hoisted_35 = { key: 4 }
const _hoisted_36 = { key: 5 }
const _hoisted_37 = { key: 6 }

import { computed, ref } from 'vue';
import { useQuery } from '@vue/apollo-composable';
import { CodeDocument, CodeType, CouponType } from '@/gql/graphql';
import {
  BAlert,
  BBadge,
  BButton,
  BButtonGroup,
  BModal,
  BSpinner,
} from 'bootstrap-vue-next';
import { ORGANIZATION_USER_ROLES } from '@/constants';
import { formatDate, deepParseDates } from '@/utils/date-utils';
import { highlightJson } from '@/utils/prism-utils';
import { capitalizeFirstLetter } from '@/utils/string-utils';
import CouponUpdate from '@/components/code/CouponUpdate.vue';
import CodeUpdate from '@/components/code/CodeUpdate.vue';
import KitUpdate from '@/components/code/KitUpdate.vue';
import { openRouterLink } from '@/utils/router-utils';

// --- Component properties ---

export default /*@__PURE__*/_defineComponent({
  __name: 'CodeDetail',
  props: {
  code: { type: String, required: true },
},
  setup(__props) {

const props = __props;

// --- Component state ---
const selectedCoupon = ref<CouponType | null>(null);
const showModalCodeUpdate = ref(false);
const showModalCouponDetail = ref(false);
const showModalCouponUpdate = ref(false);
const showModalKitDetail = ref(false);
const showModalKitUpdate = ref(false);

// --- Code Object ---
const code = computed<CodeType | null>(() => {
  const codeRes = codeQueryResult.value?.code;
  if (!codeRes) {
    return null;
  }
  return deepParseDates(codeRes) as CodeType;
});

//--- GRAPHQL CODE QUERY ---
const {
  result: codeQueryResult,
  loading: codeQueryInProgress,
  error: codeQueryError,
  refetch: refetchCode,
} = useQuery(CodeDocument, {
  codeString: props.code,
  adminAccess: true,
});

function requestRefetchCode() {
  refetchCode()
    ?.catch((err) => {
      console.error('Refetch code failed:', err);
    })
    ?.then(() => {
      console.debug('Refetched code');
    });
}

function getOrganizationDetails(code: CodeType) {
  // check organization association
  if (!code.organization) {
    return 'not assigned';
  }
  // identify organization owner
  const owner = code.organization.usersAssociated?.find(
    (assoc) =>
      assoc &&
      assoc.userRole === ORGANIZATION_USER_ROLES.OWNER &&
      assoc.removedAt === null
  );
  // return org name + owner email
  return code.organization.name + (owner ? ` (${owner.user?.email})` : '');
}

function codeUpdateRequested() {
  console.debug('Code update requested');
  showModalCodeUpdate.value = true;
}

function couponDetailsRequested(coupon: CouponType) {
  console.debug('Coupon details requested:', coupon.couponType);
  selectedCoupon.value = coupon;
  showModalCouponDetail.value = true;
}

function couponUpdateRequested(coupon: CouponType) {
  console.debug('Coupon update requested:', coupon.couponType);
  selectedCoupon.value = coupon;
  showModalCouponUpdate.value = true;
}

function kitDetailsRequested() {
  console.debug('Kit details requested');
  if (!code.value?.kit) {
    console.error('Kit details requested, but kit is not available');
    return;
  }
  showModalKitDetail.value = true;
}

function kitUpdateRequested() {
  console.debug('Kit update requested');
  if (!code.value?.kit) {
    console.error('Kit update requested, but kit is not available');
    return;
  }
  showModalKitUpdate.value = true;
}

function closeAndRefresh() {
  closeModals();
  requestRefetchCode();
}

function closeModals() {
  selectedCoupon.value = null;
  showModalCodeUpdate.value = false;
  showModalCouponDetail.value = false;
  showModalCouponUpdate.value = false;
  showModalKitDetail.value = false;
  showModalKitUpdate.value = false;
}

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(BButton), {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(openRouterLink)({ name: 'AdminCodesList' }, _ctx.$router, $event))),
      variant: "outline-dark",
      class: "mb-3",
      size: "sm"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_font_awesome_icon, {
          icon: "angle-left",
          class: "me-2"
        }),
        _cache[4] || (_cache[4] = _createTextVNode(" Back to All Codes ", -1))
      ]),
      _: 1
    }),
    _createElementVNode("h1", null, [
      _createVNode(_component_font_awesome_icon, {
        icon: ['fas', 'barcode'],
        class: "me-2"
      }),
      _createTextVNode(" " + _toDisplayString(props.code), 1)
    ]),
    _cache[44] || (_cache[44] = _createElementVNode("hr", null, null, -1)),
    _createVNode(_unref(BAlert), {
      modelValue: _unref(codeQueryError),
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(codeQueryError) ? (codeQueryError).value = $event : null)),
      variant: "danger",
      class: "mt-3"
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(codeQueryError)?.message) + " ", 1),
        _createVNode(_unref(BButton), {
          onClick: requestRefetchCode,
          variant: "outline-dark",
          class: "btn-sm"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_font_awesome_icon, { icon: ['fas', 'sync'] }),
            _cache[5] || (_cache[5] = _createTextVNode(" Retry", -1))
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    (_unref(codeQueryInProgress))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_unref(BSpinner), { label: "Loading code details..." })
        ]))
      : _createCommentVNode("", true),
    (code.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("p", _hoisted_4, [
              _cache[6] || (_cache[6] = _createElementVNode("strong", null, "Code: ", -1)),
              _createTextVNode(" " + _toDisplayString(code.value.code), 1)
            ]),
            _createElementVNode("p", _hoisted_5, [
              _cache[7] || (_cache[7] = _createElementVNode("strong", null, "Order: ", -1)),
              (code.value.orderRef)
                ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(code.value.orderRef), 1))
                : (_openBlock(), _createElementBlock("span", _hoisted_7, " not specified"))
            ]),
            _createElementVNode("p", _hoisted_8, [
              _cache[8] || (_cache[8] = _createElementVNode("strong", null, "Organization: ", -1)),
              _createTextVNode(" " + _toDisplayString(getOrganizationDetails(code.value)), 1)
            ]),
            _createElementVNode("p", _hoisted_9, [
              _cache[9] || (_cache[9] = _createElementVNode("strong", null, "Comment: ", -1)),
              (code.value.comment)
                ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(code.value.comment), 1))
                : (_openBlock(), _createElementBlock("span", _hoisted_11, " not specified"))
            ]),
            _createVNode(_unref(BButton), {
              variant: "outline-secondary",
              size: "sm",
              onClick: codeUpdateRequested
            }, {
              default: _withCtx(() => [
                _createVNode(_component_font_awesome_icon, {
                  icon: "pencil",
                  class: "me-1"
                }),
                _cache[10] || (_cache[10] = _createTextVNode(" Edit ", -1))
              ]),
              _: 1
            })
          ]),
          (code.value.kit)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createElementVNode("h3", null, [
                  _createVNode(_unref(BBadge), {
                    variant: "primary",
                    class: "me-2"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_font_awesome_icon, {
                        icon: ['fas', 'cube'],
                        class: "me-2"
                      }),
                      _cache[11] || (_cache[11] = _createTextVNode(" Kit ", -1))
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("p", _hoisted_13, [
                  _cache[12] || (_cache[12] = _createElementVNode("strong", null, "Name: ", -1)),
                  _createTextVNode(" " + _toDisplayString(code.value.kit.name), 1)
                ]),
                _createElementVNode("p", _hoisted_14, [
                  _cache[13] || (_cache[13] = _createElementVNode("strong", null, "Barcode: ", -1)),
                  _createTextVNode(" " + _toDisplayString(code.value.kit.barcode), 1)
                ]),
                _createElementVNode("p", _hoisted_15, [
                  _cache[14] || (_cache[14] = _createElementVNode("strong", null, "UMI length: ", -1)),
                  _createTextVNode(" " + _toDisplayString(code.value.kit.umiLength), 1)
                ]),
                _createElementVNode("p", _hoisted_16, [
                  _cache[15] || (_cache[15] = _createElementVNode("strong", null, "Samples: ", -1)),
                  _createTextVNode(" " + _toDisplayString(code.value.kit.sampleCount), 1)
                ]),
                _createElementVNode("p", _hoisted_17, [
                  _cache[16] || (_cache[16] = _createElementVNode("strong", null, "Manufactured: ", -1)),
                  _createTextVNode(" " + _toDisplayString(_unref(formatDate)(code.value.kit.manufacturedAt)), 1)
                ]),
                _createElementVNode("p", _hoisted_18, [
                  _cache[17] || (_cache[17] = _createElementVNode("strong", null, "Expiration: ", -1)),
                  _createTextVNode(" " + _toDisplayString(code.value.kit.expirationMonths) + " months from manufacture date ", 1)
                ]),
                _createElementVNode("p", _hoisted_19, [
                  _cache[18] || (_cache[18] = _createElementVNode("strong", null, "Description: ", -1)),
                  _createTextVNode(" " + _toDisplayString(code.value.kit.description), 1)
                ]),
                _createElementVNode("p", _hoisted_20, [
                  _cache[19] || (_cache[19] = _createElementVNode("strong", null, "Version: ", -1)),
                  _createTextVNode(" " + _toDisplayString(code.value.kit.version ? code.value.kit.version : 'not specified'), 1)
                ]),
                _createVNode(_unref(BButtonGroup), null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(BButton), {
                      variant: "outline-secondary",
                      size: "sm",
                      onClick: kitUpdateRequested
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_font_awesome_icon, {
                          icon: "pencil",
                          class: "me-1"
                        }),
                        _cache[20] || (_cache[20] = _createTextVNode(" Edit ", -1))
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(BButton), {
                      variant: "outline-secondary",
                      size: "sm",
                      onClick: kitDetailsRequested
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_font_awesome_icon, {
                          icon: "eye",
                          class: "me-1"
                        }),
                        _cache[21] || (_cache[21] = _createTextVNode(" View details ", -1))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          (code.value.license)
            ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                _cache[22] || (_cache[22] = _createElementVNode("strong", null, "License: ", -1)),
                _createElementVNode("span", null, _toDisplayString(code.value.license.licenseType), 1)
              ]))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(code.value.coupons, (coupon, cidx) => {
            return (_openBlock(), _createElementBlock(_Fragment, { key: cidx }, [
              coupon
                ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                    _createElementVNode("h3", _hoisted_23, [
                      _createVNode(_unref(BBadge), {
                        variant: 
                coupon.couponType?.includes('compute') ? 'warning' : 'success'
              ,
                        class: "me-2"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_font_awesome_icon, {
                            icon: ['fas', 'ticket'],
                            class: "me-2"
                          }),
                          _createTextVNode(" " + _toDisplayString(_unref(capitalizeFirstLetter)(coupon.couponType)) + " coupon ", 1)
                        ]),
                        _: 2
                      }, 1032, ["variant"])
                    ]),
                    _createElementVNode("p", null, [
                      _cache[23] || (_cache[23] = _createElementVNode("strong", null, "Status: ", -1)),
                      _createTextVNode(" " + _toDisplayString(coupon.unitsRemaining) + " of " + _toDisplayString(coupon.unitsTotal) + " " + _toDisplayString(coupon.units) + " remaining", 1),
                      _cache[24] || (_cache[24] = _createElementVNode("br", null, null, -1)),
                      _cache[25] || (_cache[25] = _createElementVNode("strong", null, "Created: ", -1)),
                      _createTextVNode(" " + _toDisplayString(_unref(formatDate)(coupon.createdAt)), 1),
                      _cache[26] || (_cache[26] = _createElementVNode("br", null, null, -1)),
                      _cache[27] || (_cache[27] = _createElementVNode("strong", null, "Expires: ", -1)),
                      _createTextVNode(" " + _toDisplayString(_unref(formatDate)(coupon.expiresAt, 'no expiration')), 1)
                    ]),
                    _createVNode(_unref(BButtonGroup), null, {
                      default: _withCtx(() => [
                        _createVNode(_unref(BButton), {
                          variant: "outline-secondary",
                          size: "sm",
                          onClick: ($event: any) => (couponUpdateRequested(coupon))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_font_awesome_icon, {
                              icon: "pencil",
                              class: "me-1"
                            }),
                            _cache[28] || (_cache[28] = _createTextVNode(" Edit ", -1))
                          ]),
                          _: 1
                        }, 8, ["onClick"]),
                        _createVNode(_unref(BButton), {
                          variant: "outline-secondary",
                          size: "sm",
                          onClick: ($event: any) => (couponDetailsRequested(coupon))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_font_awesome_icon, {
                              icon: "eye",
                              class: "me-1"
                            }),
                            _cache[29] || (_cache[29] = _createTextVNode(" View details ", -1))
                          ]),
                          _: 1
                        }, 8, ["onClick"])
                      ]),
                      _: 2
                    }, 1024)
                  ]))
                : _createCommentVNode("", true)
            ], 64))
          }), 128)),
          (code.value.kit && showModalKitDetail.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                _createVNode(_unref(BModal), {
                  modelValue: showModalKitDetail.value,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((showModalKitDetail).value = $event)),
                  onHide: closeModals,
                  size: "lg"
                }, {
                  title: _withCtx(() => [
                    _createVNode(_component_font_awesome_icon, {
                      icon: ['fas', 'cube'],
                      class: "me-2"
                    }),
                    _createTextVNode(" " + _toDisplayString(code.value.kit.name) + " kit details ", 1)
                  ]),
                  footer: _withCtx(() => [
                    _createVNode(_unref(BButton), {
                      onClick: closeModals,
                      variant: "secondary"
                    }, {
                      default: _withCtx(() => [...(_cache[37] || (_cache[37] = [
                        _createTextVNode(" Close ", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("p", _hoisted_25, [
                      _cache[30] || (_cache[30] = _createElementVNode("strong", null, "Barcode: ", -1)),
                      _createTextVNode(" " + _toDisplayString(code.value.kit.barcode), 1)
                    ]),
                    _createElementVNode("p", _hoisted_26, [
                      _cache[31] || (_cache[31] = _createElementVNode("strong", null, "UMI length: ", -1)),
                      _createTextVNode(" " + _toDisplayString(code.value.kit.umiLength), 1)
                    ]),
                    _createElementVNode("p", _hoisted_27, [
                      _cache[32] || (_cache[32] = _createElementVNode("strong", null, "Samples: ", -1)),
                      _createTextVNode(" " + _toDisplayString(code.value.kit.sampleCount), 1)
                    ]),
                    _createElementVNode("p", _hoisted_28, [
                      _cache[33] || (_cache[33] = _createElementVNode("strong", null, "Manufactured: ", -1)),
                      _createTextVNode(" " + _toDisplayString(_unref(formatDate)(code.value.kit.manufacturedAt)), 1)
                    ]),
                    _createElementVNode("p", _hoisted_29, [
                      _cache[34] || (_cache[34] = _createElementVNode("strong", null, "Expiration: ", -1)),
                      _createTextVNode(" " + _toDisplayString(code.value.kit.expirationMonths) + " months from manufacture date ", 1)
                    ]),
                    _createElementVNode("p", _hoisted_30, [
                      _cache[35] || (_cache[35] = _createElementVNode("strong", null, "Description: ", -1)),
                      _createTextVNode(" " + _toDisplayString(code.value.kit.description), 1)
                    ]),
                    _createElementVNode("p", _hoisted_31, [
                      _cache[36] || (_cache[36] = _createElementVNode("strong", null, "Version: ", -1)),
                      _createTextVNode(" " + _toDisplayString(code.value.kit.version ? code.value.kit.version : 'not specified'), 1)
                    ]),
                    _createElementVNode("pre", {
                      class: "code-highlight",
                      innerHTML: _unref(highlightJson)(code.value.kit.details)
                    }, null, 8, _hoisted_32)
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]))
            : _createCommentVNode("", true),
          (selectedCoupon.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                _createVNode(_unref(BModal), {
                  modelValue: showModalCouponDetail.value,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((showModalCouponDetail).value = $event)),
                  onHide: closeModals,
                  size: "lg"
                }, {
                  title: _withCtx(() => [
                    _createVNode(_component_font_awesome_icon, {
                      icon: "ticket",
                      class: "me-2"
                    }),
                    _createTextVNode(" " + _toDisplayString(_unref(capitalizeFirstLetter)(selectedCoupon.value.couponType)) + " coupon details ", 1)
                  ]),
                  footer: _withCtx(() => [
                    _createVNode(_unref(BButton), {
                      onClick: closeModals,
                      variant: "secondary"
                    }, {
                      default: _withCtx(() => [...(_cache[43] || (_cache[43] = [
                        _createTextVNode(" Close ", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("p", null, [
                      _cache[38] || (_cache[38] = _createElementVNode("strong", null, "Status: ", -1)),
                      _createTextVNode(" " + _toDisplayString(selectedCoupon.value.unitsRemaining) + " of " + _toDisplayString(selectedCoupon.value.unitsTotal) + " " + _toDisplayString(selectedCoupon.value.units) + " remaining", 1),
                      _cache[39] || (_cache[39] = _createElementVNode("br", null, null, -1)),
                      _cache[40] || (_cache[40] = _createElementVNode("strong", null, "Created: ", -1)),
                      _createTextVNode(" " + _toDisplayString(_unref(formatDate)(selectedCoupon.value.createdAt)), 1),
                      _cache[41] || (_cache[41] = _createElementVNode("br", null, null, -1)),
                      _cache[42] || (_cache[42] = _createElementVNode("strong", null, "Expires: ", -1)),
                      _createTextVNode(" " + _toDisplayString(_unref(formatDate)(selectedCoupon.value.expiresAt, 'no expiration')), 1)
                    ]),
                    _createElementVNode("pre", {
                      class: "code-highlight",
                      innerHTML: _unref(highlightJson)(selectedCoupon.value.details)
                    }, null, 8, _hoisted_34)
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]))
            : _createCommentVNode("", true),
          (showModalCodeUpdate.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                _createVNode(CodeUpdate, {
                  code: code.value,
                  show: showModalCodeUpdate.value,
                  onClose: closeModals,
                  onCloseAndRefresh: closeAndRefresh
                }, null, 8, ["code", "show"])
              ]))
            : _createCommentVNode("", true),
          (code.value.kit && showModalKitUpdate.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                _createVNode(KitUpdate, {
                  kit: code.value.kit,
                  show: showModalKitUpdate.value,
                  onClose: closeModals,
                  onCloseAndRefresh: closeAndRefresh
                }, null, 8, ["kit", "show"])
              ]))
            : _createCommentVNode("", true),
          (selectedCoupon.value && showModalCouponUpdate.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                _createVNode(CouponUpdate, {
                  coupon: selectedCoupon.value,
                  show: showModalCouponUpdate.value,
                  onClose: closeModals,
                  onCloseAndRefresh: closeAndRefresh
                }, null, 8, ["coupon", "show"])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})